export default "__VITE_ASSET__BHsp1nT4__"